import { getFeature } from 'Cloud/Application/FeaturesEs6';

// TODO: Потенциально перенести сюда все фичи по видосам

/* CLOUDWEB-17767 Управление воспроизведением видео с клавиатуры */
export const showCentralRewindButtons: boolean = getFeature('show-central-rewind-buttons') || false;
